import React from "react";
import "../../../styles/globalStyles.css";
import styles from "./Team.module.css";
import { useImageZoom } from "../../utils/useImageZoom";

export default function Team() {
  const { zoomedSrc, setZoomedSrc, isVisible, closeZoom } = useImageZoom();

  return (
    <section id="aboutUs" className="sectionContainer dark">
      <div className="sectionTitle">
        <h2>Poznaj nas</h2>
      </div>
      <div className={styles.teamContainer}>
        <div className={styles.teamMember}>
          <div className={styles.image}>
            <img
              src={`${process.env.PUBLIC_URL}/Images/Other/owner.webp`}
              alt="Member"
              onClick={() =>
                setZoomedSrc(
                  `${process.env.PUBLIC_URL}/Images/Other/owner.webp`
                )
              }
              className={styles.owner}
            />

            {zoomedSrc && (
              <div
                className={`${styles.overlay} ${isVisible ? styles.overlayOpen : ""}`}
                onClick={closeZoom}
              >
                <div
                  className={`${styles.imageWrapper} ${isVisible ? styles.imageOpen : ""}`}
                >
                  <img
                    src={zoomedSrc}
                    alt="zoom"
                    className={styles.zoomImage}
                  />
                </div>
              </div>
            )}
          </div>
          <div className={styles.memberInfo}>
            <h1>Ania</h1>
            <p>
              Jest absolwentką informatyki. Od wielu lat pasjonuje się
              programowaniem, a największą satysfakcję daje jej analiza i
              rozwiązanie problemu. Zawsze angażuję się w swoją pracę na 100%,
              dbając o każdy szczegół. Jest osobą, która lubi pracować i nie
              znosi nudy. Dlatego poza informatyką rozwija swoją pasję, jaką
              jest fotografia. To właśnie jej zdjęcia będziesz mógł zakupić w
              naszym sklepie. Na co dzień można ją poznać jako osobę dobrze
              zorganizowaną, ambitną, pracowitą i uśmiechniętą, ciekawą świata,
              która zaskoczy Cię niejednym swoim pomysłem.
            </p>
          </div>
        </div>
      </div>
      <div className="buttonSection">
        <div className="backButtonContainer">
          <button className="backButton" onClick={() => window.history.back()}>
            Powrót
          </button>
        </div>
      </div>
    </section>
  );
}
